export default function UserIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} width="23" height="29" viewBox="0 0 23 29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.54466 6.77083C4.54466 3.02931 7.58149 0 11.3229 0C15.0643 0 18.1012 3.02931 18.1012 6.77083C18.1012 10.5124 15.0643 13.5417 11.3229 13.5417C7.58149 13.5417 4.54466 10.5124 4.54466 6.77083Z"
        fill="#94A3B8"
      />
      <path
        d="M0.848286 21.3034C6.28767 15.6223 16.2851 15.3129 21.8422 21.3128L22.2235 21.694C22.5261 21.9967 22.6914 22.4102 22.6806 22.8381C22.6699 23.266 22.4841 23.6707 22.1666 23.9578C19.3039 26.5465 15.5048 28.125 11.3406 28.125C7.17637 28.125 3.37719 26.5465 0.5145 23.9578C0.197039 23.6707 0.0112393 23.266 0.000493205 22.8381C-0.0102528 22.4102 0.154995 21.9967 0.457646 21.694L0.848286 21.3034Z"
        fill="#94A3B8"
      />
    </svg>
  )
}
